import { TextStyle } from "react-native";

export function getWidgetNoteTextShadowStyle(): TextStyle {
  return {
    backgroundColor: "transparent",
    textShadowOffset: { width: 0, height: 0 },
    textShadowRadius: 3,

    textShadowColor: "#000",
  };
}
